import { render, staticRenderFns } from "./UIFormEntity.vue?vue&type=template&id=5b4052fc"
import script from "./UIFormEntity.vue?vue&type=script&lang=js"
export * from "./UIFormEntity.vue?vue&type=script&lang=js"
import style0 from "./UIFormEntity.vue?vue&type=style&index=0&id=5b4052fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports